import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import useSWRImmutable from 'swr/immutable';

import { type BonusOrigin, normalizeBonuses } from '@/api/cms';
import { fetcherCMS } from '@/modules/api';
import {
  CMS_CLIENT_QUERY_TIME,
  CMSSortTypeEnum,
  createCMSQuery,
  DEFAULT_CMS_PAGE_SIZE,
  getCMSDurationQuery,
  getCMSImageFieldsUrl,
  getCMSLocale,
  getCMSSchedulerQuery,
} from '@/modules/cms';
import { useMatchingSections } from '@/modules/restrictions/hooks/useAccessSections';

export const useCMSCashierBonuses = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const query = useMemo(
    () =>
      createCMSQuery({
        sort: [`order:${CMSSortTypeEnum.ASC}`],
        filters: {
          $and: [
            getCMSSchedulerQuery(CMS_CLIENT_QUERY_TIME),
            getCMSDurationQuery(CMS_CLIENT_QUERY_TIME),
            { cashier_toggle: { $eq: true } },
          ],
        },
        populate: {
          scheduler: '*',
          ...getCMSImageFieldsUrl('image'),
          min_dep_v2: '*',
          spin_value: '*',
        },
        ...getCMSLocale(language),
        pagination: {
          pageSize: DEFAULT_CMS_PAGE_SIZE,
        },
      }),
    [language]
  );

  const {
    data = [],
    error,
    isLoading,
  } = useSWRImmutable<BonusOrigin[]>(`/bonuses-news?${query}`, fetcherCMS);

  const bonuses = useMatchingSections(normalizeBonuses(data));

  return {
    data,
    isLoading,
    isError: error,
    bonuses,
  };
};
